module.exports = __webpack_public_path__ + "img/page23.5e06e1ba.jpg";